export default {
  'device.auth': '设备认证页',
};
